import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../contexts/AuthContext';

const LOCAL_STORAGE_KEY = 'hemma_cookie_consent';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        try {
            const accepted = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (!accepted) {
                setIsVisible(true);
            }
        } catch (e) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        try {
            localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
        } catch (e) {

        }
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return createPortal(
        <div className="fixed bottom-4 md:bottom-6 left-4 md:left-6 z-[9999]" style={{ maxWidth: 'calc(100vw - 32px)' }}>
            <div
                className="text-white text-center"
                style={{
                    width: 688,
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    height: 452,
                    padding: 44.61,
                    background:
                        'linear-gradient(0deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.02) 100%), radial-gradient(ellipse 92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.20) 0%, rgba(40, 227, 218, 0) 100%), #081423',
                    borderRadius: 12,
                    border: '1px solid rgba(40, 227, 218, 0.25)',
                    display: 'inline-flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 29.74
                }}
                dir="rtl"
            >
                <div
                    style={{
                        width: '100%',
                        maxWidth: 486,
                        textAlign: 'center',
                        color: '#D5D2D2',
                        fontSize: 12,
                        fontFamily: 'Alexandria',
                        fontWeight: 700,
                        lineHeight: '24px',
                        wordWrap: 'break-word',
                        margin: '0 auto'
                    }}
                >
                    {isAuthenticated && (user?.name || user?.username) ? `اهلا ${user?.name || user?.username} في منصة همة` : 'اهلا بك في منصة همة'}<br/>
                    عشان تكون تجربتك أسهل وأسرع، نستخدم ملفات تعريف الارتباط للمساعدة في تحسين خدماتنا وتقديم تجربة استخدام أفضل لك.<br/>
                    وجودك معنا وتصفحك للمنصة يعني إنك موافق على استخدامها، وكل شي بيكون آمن وواضح لك.
                </div>
                <div className="mt-8 flex flex-col items-center gap-3">
                    <button
                        onClick={handleAccept}
                        className="hover:opacity-90 transition"
                        style={{
                            width: 73,
                            height: 46,
                            paddingLeft: 4.5,
                            paddingRight: 4.5,
                            paddingTop: 3,
                            paddingBottom: 3,
                            background:
                                'radial-gradient(ellipse 43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
                            borderRadius: 4.5,
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 3,
                            display: 'inline-flex',
                            color: 'white',
                            fontSize: 14,
                            fontFamily: 'Alexandria',
                            fontWeight: 500,
                            lineHeight: '9px'
                        }}
                    >
                        موافقة
                    </button>
                    <a
                        href="/terms"
                        style={{
                            width: 73,
                            textAlign: 'center',
                            color: '#1D8F90',
                            fontSize: 9,
                            fontFamily: 'Alexandria',
                            fontWeight: 500,
                            lineHeight: '18px',
                            wordWrap: 'break-word'
                        }}
                        className="hover:opacity-90"
                    >
                        عرضها
                    </a>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default CookieConsent;


